<template>
  <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      offset-y
      max-width="18em"
      min-width="auto"
      left
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
          v-model="dateFormatted"
          :label="label"
          hint="Ve formátu D.M.RRRR"
          persistent-hint
          prepend-icon="mdi-calendar"
          v-bind="attrs"
          @blur="date = parseDate(dateFormatted)"
          v-on="on"
          :rules="[rules.isDate]"
      ></v-text-field>
    </template>
    <v-date-picker
        v-model="date"
        no-title
        locale="cs-cz"
        @input="menu = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "DateField",

  props: {
    modelValue: String,
    label: String,
  },

  model: {
    prop: 'modelValue',
    event: 'change'
  },

  data: vm => ({
    date: null,
    dateFormatted: null,
    menu: false,
    rules: {
      isDate: value => {
        try {
          if (Date.parse(vm.parseDate(value))) {
            return true;
          }
        } catch (e) {
          console.log('isDate failed', e);
        }
        return 'Zadejte datum ve tvaru d.m.rrrr';
      },
    },
  }),

  watch: {
    date (val) {
      this.dateFormatted = this.formatDate(val);
      this.$emit('change', val);
    },
    modelValue: {
      immediate: true,
      handler(val) {
        this.date = val;
      },
    },
  },

  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${parseInt(day)}.${parseInt(month)}.${parseInt(year)}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
  },
}
</script>

<style scoped>

</style>